import { Http } from '../utils/Http'
import { SerializationHelper } from '../utils/SerializationHelper'
import { AbstractModel } from './AbstractModel'

export class Game extends AbstractModel {
  static readonly classPath = 'rally-round'
  id = 0;
  name: string|null = null;
  rallyRoundId = 0

  static async getAllChallenges<T extends AbstractModel> (this: new() => T, { params }: { params?: Array<string | number> }): Promise<any> {
    const challenges = await (await Http.request('/api/challenges')).json()
    return SerializationHelper.toInstanceArray(this, challenges)
  }

  static async getForRallyRound (rallyRoundId: number) {
    return await this.getAll({ params: [rallyRoundId, 'challenges'] })
  }
}
